import { render, staticRenderFns } from "./AgendaCita.vue?vue&type=template&id=04702f04"
import script from "./AgendaCita.vue?vue&type=script&lang=js"
export * from "./AgendaCita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports